module.exports = __webpack_public_path__ + "static/img/Tom_Jonas_mobile.3796b6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tom_Jonas_mobile.jpg
// module id = iYZe
// module chunks = 0